// NPM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Helmet } from 'react-helmet';
import { isEmpty } from 'lodash';

// COMPONENT
import DeletedCustomerProfileListComponent from 'Components/customer-management/deleted-customer-profile-list';

// HELPERS
import { encode } from 'Helpers/enc';
import { toaster } from 'Helpers/toaster';

// SERVICE
import { fetchDeletedCustomerList } from 'Services/customer.service';
import { Sorting, SortingMode } from '../../../types/common.types';

// ANT COMPONENTS
import { Pagination } from '@life-line-lab/components-react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

// HOOKS
import useQuery from 'Hooks/query.hook';
import { useItemsPerPage, useSession } from 'Hooks/index';
import usePagination from "Hooks/pagination.hook";

// CONSTANTS
import { DEFAULT_MAX_PER_PAGE } from 'Components/shared/constants';
import { CustomerApprovalStatus } from 'Types/customer-form.types';

//ATOM
import { GlobalFilterAtom } from 'Recoil/global_filter.atom'

const toNum = (data) => {
  if (typeof data === "string") {
    if (data.match(/^[0-9]+$/)) {
      return parseInt(data);
    } else {
      return 1;
    }
  }
  return data;
}

const DeletedCustomerProfilePage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const query = useQuery();

  const { org } = useSession();

  const page = query.get('page') || 1;
  const initialQueryParams = { page, offset: (toNum(page) - 1) * toNum(itemPerPage) }

  const initialFilters = {};
  const initialSorting = { sortBy: 'name', mode: SortingMode.DESC };

  const [filters, setFilters] = useState<{ [key: string]: string | boolean | undefined }>(initialFilters);
  const [list, setList] = useState<any>([]);

  const [sorting, setSorting] = useState<Sorting>(initialSorting);
  const globalFilterValue = useRecoilValue(GlobalFilterAtom);
  const [selectedOrgIDs, setSelectedOrgIDs] = useState<string[]>([])

  const [currentListCount, setCurrentListCount] = useState(0);
  const { paginationComponent, itemPerPage, queryParams, setQueryParams } = usePagination({
    currentListCount,
  });

  useEffect(() => {
    handleFetchDeletedCustomerList();
  }, [queryParams.offset, filters, sorting, itemPerPage]);

  const handlePaginationChange = (page?: string) => {
    let path = '';

    if (page) {
      path = `/customer-management/profile?page=${page}`;
    }
    else {
      path = '/customer-management/profile';
    }
    history.push(path)
  }

  useEffect(() => {
    handleFetchDeletedCustomerList()
  }, [selectedOrgIDs])

  useEffect(() => {
    let orgIDs: string[] = [];
    if (!isEmpty(globalFilterValue.companyIds)) {
      globalFilterValue?.companyIds?.map(orgSelected => {
        orgIDs.push(orgSelected);
      })
      setSelectedOrgIDs(orgIDs)
    }else
    if (!isEmpty(globalFilterValue.logisticsProviderIds)) {
      globalFilterValue?.logisticsProviderIds?.map(orgSelected => {
        orgIDs.push(orgSelected);
      })
      setSelectedOrgIDs(orgIDs)
    }else{
      orgIDs.push(org._id)
      setSelectedOrgIDs(orgIDs)
    }
  }, [globalFilterValue])

  const handleSort = async (sortBy) => {
    if (sorting.sortBy === sortBy) {
      let mode = SortingMode.NEITHER;
      switch (sorting.mode) {
        case SortingMode.ASC: {
          mode = SortingMode.DESC;
          break;
        }
        case SortingMode.DESC: {
          mode = SortingMode.ASC;
          break;
        }
        case SortingMode.NEITHER: {
          mode = SortingMode.DESC;
          break;
        }
      }
      setSorting({ ...sorting, mode });
    }
    else {
      setSorting({ sortBy: sortBy, mode: SortingMode.DESC });
    }
  }

  const handleFetchDeletedCustomerList = async () => {
    //If there is no global filter, set it as own
    let orgIDs: string[] = [];
    orgIDs.push(org._id)
    const responseData = await fetchDeletedCustomerList(
      filters,
      !isEmpty(selectedOrgIDs) ? selectedOrgIDs : orgIDs,
      CustomerApprovalStatus.APPROVED,
      {
        offset: queryParams.offset,
        limit: toNum(itemPerPage),
      },
      sorting
    );

    if (responseData && !responseData.error) {
      setList(responseData);
      setCurrentListCount(responseData.length)

    } else {
      toaster("error", responseData.error.message);
    }
  }

  return (
    <div className="customer-management customer-profile-page">
      <Helmet>
        <title>{t('pageTitle.deletedCustomerProfile')}</title>
      </Helmet>
      <div className="title mb-5">{t("title.customerManagement")}</div>
      <div className="subtitle mb-20">{t("title.deletedCustomerProfile")}</div>
      <DeletedCustomerProfileListComponent
        list={list}
        onView={(record) => {
          const id = encode(record._id);
          history.push(`/customer-management/profile/${id}/view`);
        }}
        onSort={handleSort}
        onFilter={(filter) => { setFilters(filter) }}
        sorting={sorting}
      />

      <div className="my-30">{paginationComponent}</div>
    </div>
  )
}

export default DeletedCustomerProfilePage;
